import { Component, OnInit, OnDestroy, Inject, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { AlertService } from "@service/alert.service";
import { FireAnalyticsService } from "@service/fire-analytics.service";
import { SharedService } from "@service/shared.service";

@Component({
    selector: "app-portfolio-sip-setting",
    templateUrl: "./sip-setting.component.html",
    styleUrls: ["./sip-setting.component.scss"],
})
export class AppSipSettingComponent implements OnInit, OnDestroy {
    sipForm: UntypedFormGroup;
    selectedDay: any;
    days: any[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20",
        "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"];

    @ViewChild('dateMenu') dateMenu: any;
    constructor(
        private dialogRef: MatDialogRef<AppSipSettingComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any, 
        private formBuilder: UntypedFormBuilder, 
        private alertService: AlertService, 
        private sharedService: SharedService,
        private analytics: FireAnalyticsService
    ) { }
    ngOnDestroy() {
    }
    ngOnInit() {
        this.selectedDay = this.data.sipDate;
        this.sipForm = this.formBuilder.group({
            sipDate: [this.data.sipDate || "", Validators.required],
            sipAmount: [
                { value: this.data.sipAmount ? this.data.sipAmount : "", disabled: this.data.onlyDate },
                Validators.required,
            ],
        });
    }
    onSubmitForm() {
        let data = {
            sipDate: this.sipForm.controls["sipDate"].value,
            sipAmount: this.sipForm.controls["sipAmount"].value,
        };
        this.sharedService.updateSip(this.data.id, data).subscribe({
            next: (res: any) => {
                this.analytics.logEvents('Set Reminder', {date: data.sipDate, amount: data.sipAmount})
                this.alertService.success(res.message);
                this.dialogRef.close(data);
            }
        });
    }

    closeDialog() {
        this.dialogRef.close();
    }

    onSelectDay(day: any) {
        this.selectedDay = day;
    }

    confirmDay() {
        this.sipForm.controls['sipDate'].setValue(this.selectedDay);
        this.dateMenu.closeMenu();
    }
}
